import React from "react";
import { CalendarCheck, Users, Rocket } from "lucide-react";

const STEPS = [
  {
    num: "01",
    icon: CalendarCheck,
    title: "Book a Call",
    desc: "We understand your business needs and goals.",
  },
  {
    num: "02",
    icon: Users,
    title: "Team Setup",
    desc: "We assign and prepare agents based on your requirements.",
  },
  {
    num: "03",
    icon: Rocket,
    title: "Launch & Optimize",
    desc: "We start operations and improve performance weekly.",
  },
];

const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      style={{
        position: "relative",
        padding: "96px 0 144px",
        background: "rgba(8,8,8,0.70)",
        overflow: "hidden",
      }}
    >
      {/* Decorative background */}
      <div style={{ position: "absolute", inset: 0 }}>
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: "1px", background: "linear-gradient(90deg, transparent, rgba(210,170,60,0.15), transparent)" }} />
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "800px",
            height: "800px",
            borderRadius: "50%",
            filter: "blur(200px)",
            background: "radial-gradient(circle, rgba(210,170,60,0.05) 0%, transparent 70%)",
          }}
        />
      </div>

      <div style={{ position: "relative", maxWidth: "1280px", margin: "0 auto", padding: "0 24px" }}>
        {/* Section header */}
        <div style={{ maxWidth: "640px", marginBottom: "80px", textAlign: "center", marginLeft: "auto", marginRight: "auto" }}>
          <div
            className="reveal"
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "10px",
              letterSpacing: "0.4em",
              color: "rgba(210,170,60,0.8)",
              textTransform: "uppercase",
              marginBottom: "20px",
            }}
          >
            How It Works
          </div>
          <h2
            className="reveal reveal-delay-1"
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: "clamp(36px, 5vw, 60px)",
              fontWeight: 300,
              lineHeight: 1.08,
              color: "#fff",
              letterSpacing: "0.02em",
              marginBottom: "24px",
            }}
          >
            Three steps to a{" "}
            <em style={{ color: "#e8c45a", fontStyle: "italic", fontWeight: 400 }}>ready-to-go team</em>.
          </h2>
          <p
            className="reveal reveal-delay-2"
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "14px",
              fontWeight: 300,
              color: "rgba(220,195,140,0.6)",
              lineHeight: 1.8,
              letterSpacing: "0.02em",
            }}
          >
            A simple, transparent process — from discovery call to active operations.
          </p>
        </div>

        {/* Steps */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: "48px",
            position: "relative",
          }}
        >
          {/* Connecting line */}
          <div
            style={{
              position: "absolute",
              top: "40px",
              left: "10%",
              right: "10%",
              height: "1px",
              background: "linear-gradient(90deg, transparent, rgba(210,170,60,0.25), transparent)",
            }}
            className="hidden md:block"
          />

          {STEPS.map((s, i) => (
            <div
              key={s.num}
              data-testid={`step-${i + 1}`}
              className="reveal"
              style={{
                textAlign: "center",
                animationDelay: `${i * 120}ms`,
              }}
            >
              {/* Step number badge */}
              <div
                style={{
                  position: "relative",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "80px",
                  height: "80px",
                  border: "1px solid rgba(210,170,60,0.25)",
                  background: "rgba(10,10,10,0.8)",
                  marginBottom: "32px",
                  boxShadow: "0 0 40px rgba(210,170,60,0.06)",
                  transition: "all 0.35s ease",
                }}
              >
                <s.icon style={{ width: "32px", height: "32px", color: "#e8c45a" }} />
                <span
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-12px",
                    fontFamily: "'Cormorant Garamond', serif",
                    fontSize: "14px",
                    fontWeight: 500,
                    background: "#e8c45a",
                    color: "#000",
                    padding: "2px 10px",
                    letterSpacing: "0.1em",
                  }}
                >
                  {s.num}
                </span>
              </div>

              <h3
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontSize: "26px",
                  fontWeight: 400,
                  color: "#fff",
                  lineHeight: 1.25,
                  letterSpacing: "0.01em",
                  marginBottom: "16px",
                }}
              >
                {s.title}
              </h3>
              <p
                style={{
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: "13px",
                  fontWeight: 300,
                  color: "rgba(255,255,255,0.5)",
                  lineHeight: 1.7,
                  letterSpacing: "0.01em",
                  maxWidth: "260px",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
